import QueueAPI from '@/API/QueueAPI'

export default {
  namespaced: true,
  state: {
    tables: [],
    enabled: true,
    fetched: false,
    noQueue: false,
  },

  getters: {
    tables: (state: any) => state.tables,
    isEnabled: (state: any) => state.enabled,
    noQueue: (state: any) => state.noQueue,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.tables = payload.tables ?? []
      state.enabled = payload.enabled ?? true
      state.noQueue = payload.noQueue ?? false
    },
    SET_ENABLED(state: any, payload: any) {
      state.enabled = payload ?? false
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any) {
      if (context.state.fetched) {
        return
      }
      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        const data = await QueueAPI.getSettings(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.error(err)
      }
    },
    async UPDATE(context: any, payload: any) {
      // @ts-ignore
      try {
        return await QueueAPI.update(payload)
      } catch (err) {
        return { response: 400, message: err?.message ?? '' }
      }
    },
  },
}
